export default __webpack_public_path__ + "static/media/image-coming-soon.f21a03ed.png";